module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/soon.55eaa47e.png";